import { Component, Input } from '@angular/core';

@Component({
  selector: 'digicem-welcome-card',
  templateUrl: './welcome-card.component.html',
})
export class WelcomeCardComponent {
  @Input() public driverName: string = '';
  @Input() public sellerName: string = '';
  @Input() public isLoading: boolean = false;
}
